import { render, staticRenderFns } from "./TransitionBio.vue?vue&type=template&id=9afa6f6e&"
import script from "./TransitionBio.vue?vue&type=script&lang=js&"
export * from "./TransitionBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports